import { Text } from '@shared/components';
import { useMeContext } from '@shared/contexts/hooks/useMeContext';
import { usePageInfo } from '@shared/features/sidekick-navigator/PageInfoContextProvider';
import { useFindShipment } from '@shared/hooks/shipments/useFindShipment';
import { ShipmentDetailsContainer } from '@shared/plugin/pages/ShipmentSidePanel/ShipmentSidePanel';
import { AddShipmentButton } from './AddShipmentButton';
import { RefreshShipmentButton } from './RefreshShipmentButton';
import { toTMS } from './TMSSidekick';

type ShipmentCardContainerProps = {
  parentUrl: string;
  referenceNumber: string;
};
export function ShipmentCardContainer({
  parentUrl,
  referenceNumber,
}: ShipmentCardContainerProps) {
  const { pageInfo } = usePageInfo();
  const tms = toTMS(pageInfo);
  const { defaultOrgId } = useMeContext();
  const info = useFindShipment({
    organizationId: defaultOrgId ?? '',
    referenceNumber,
    tms,
  });

  if (info.error || !info.shipmentId) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center gap-2">
        <Text type="body-sm" className="p-2">
          Vooma doesn't have a record of this shipment.
        </Text>
        <AddShipmentButton
          parentUrl={parentUrl}
          referenceNumber={referenceNumber}
        />
      </div>
    );
  }
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-2">
      <ShipmentDetailsContainer info={info} />
      <RefreshShipmentButton
        parentUrl={parentUrl}
        referenceNumber={referenceNumber}
      />
    </div>
  );
}
